import { type ClassName, tw, twx } from '@ctw/shared/utils/tailwind';
import { faExclamationCircle, faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { ReactNode } from 'react';

export type AlertProps = {
  header?: string;
  children?: ReactNode;
  className?: ClassName;
  type: 'error' | 'caution';
};

export const Alert = ({ header, children, className, type }: AlertProps) => (
  <div
    className={twx(
      'flex items-start space-x-2 rounded-md p-4 text-left shadow-sm',
      { 'bg-caution-badge': type === 'caution', 'bg-error-background': type === 'error' },
      className,
    )}
  >
    <FontAwesomeIcon
      icon={type === 'error' ? faExclamationCircle : faExclamationTriangle}
      className={twx('h-5 flex-none', {
        'text-caution-text': type === 'caution',
        'text-error-text': type === 'error',
      })}
    />
    <div className={tw`space-y-2`}>
      {header && (
        <div
          className={twx('font-medium', {
            'text-caution-text': type === 'caution',
            'text-error-text': type === 'error',
          })}
        >
          {header}
        </div>
      )}
      {children && (
        <div
          className={twx({
            'text-caution-text': type === 'caution',
            'text-error-text': type === 'error',
          })}
        >
          {children}
        </div>
      )}
    </div>
  </div>
);
